import { createSelector } from 'reselect';

const getCount = (
  state: import('../types/rootState').RootState
): import('../types/Counter').Counter => state.counter || {};

const getCartCount = createSelector(getCount, counts => counts.cartCount || 0);
const getWishlistCount = createSelector(getCount, counts => counts.wishlistCount || 0);

export { getCartCount, getWishlistCount };
